import React, { useState, useContext, useEffect } from "react";
import "../../styles/layouts/AdminLayout.css";
import { UserSettings } from "./UserSettings";
import EmailSettings from "./EmailSettings";
import { ProjectContext } from "../../App";
import TestEmail from "./TestEmail";
import GroupList from "../GroupList";
import CustomerList from "../CustomerList";
import RoleSettings from "./RoleSettings";
import TimesheetSettings from "./TimesheetSettings";
import ProjectSettings from "./ProjectSettings";
import EventSettings from "./EventSettings";
import CompanyProfile from "./CompanyProfile";
import Countries from "./Countries";
import { Helmet } from "react-helmet";
import { useRolePermissions } from "./RoleContext";

const Settings = () => {
  const { hasPermission } = useRolePermissions();
  const { isNavBarOpen } = useContext(ProjectContext);
  const [openSection, setOpenSection] = useState(
    localStorage.getItem("openSection") || "userSettings"
  );
  useEffect(() => {
    localStorage.setItem("openSection", openSection);
  }, [openSection]);
  const toggleSection = (section) => {
    setOpenSection(openSection === section ? section : section);
  };

  return (
    <div
      className={
        isNavBarOpen ? "settings-main-details" : "settings-main-details-close"
      }
    >
      <Helmet>
        <title>Msuite - Projects</title>
      </Helmet>
      <div className="left-right-con-settings">
        <div className="left-Navbar">
          {hasPermission("users", "update") && (
            <h3
              className={`settings-label ${
                openSection === "userSettings" ? "active" : ""
              }`}
              onClick={() => toggleSection("userSettings")}
            >
              User
            </h3>
          )}
          {hasPermission("email", "update") && (
            <h3
              className={`settings-label ${
                openSection === "emailSettings" ? "active" : ""
              }`}
              onClick={() => toggleSection("emailSettings")}
            >
              Email
            </h3>
          )}
          {hasPermission("projects", "update") && (
            <h3
              className={`settings-label ${
                openSection === "projectSettings" ? "active" : ""
              }`}
              onClick={() => toggleSection("projectSettings")}
            >
              Project
            </h3>
          )}
          {hasPermission("projects", "update") && (
            <h3
              className={`settings-label ${
                openSection === "Timesheet" ? "active" : ""
              }`}
              onClick={() => toggleSection("Timesheet")}
            >
              Timesheet
            </h3>
          )}
          <h3
            className={`settings-label ${
              openSection === "eventSettings" ? "active" : ""
            }`}
            onClick={() => toggleSection("eventSettings")}
          >
            Events
          </h3>
          {hasPermission("roles", "update") && (
            <h3
              className={`settings-label ${
                openSection === "roleSettings" ? "active" : ""
              }`}
              onClick={() => toggleSection("roleSettings")}
            >
              Roles
            </h3>
          )}
          <h3
            className={`settings-label ${
              openSection === "groupSettings" ? "active" : ""
            }`}
            onClick={() => toggleSection("groupSettings")}
          >
            Group
          </h3>
          <h3
            className={`settings-label ${
              openSection === "customerSettings" ? "active" : ""
            }`}
            onClick={() => toggleSection("customerSettings")}
          >
            Customer
          </h3>
          <h3
            className={`settings-label ${
              openSection === "companySettings" ? "active" : ""
            }`}
            onClick={() => toggleSection("companySettings")}
          >
            Company Profile
          </h3>
          <h3
            className={`settings-label ${
              openSection === "countries" ? "active" : ""
            }`}
            onClick={() => toggleSection("countries")}
          >
            Country
          </h3>
        </div>
        <div className="right-container"></div>
      </div>
      <div className="user-settings"></div>

      {openSection === "userSettings" && (
        <div
          className={
            isNavBarOpen ? "setting-container" : "setting-container-close"
          }
        >
          <h3>User Settings</h3>
          <div className="settings-details">
            <UserSettings />
          </div>
        </div>
      )}

      {openSection === "projectSettings" && (
        <div
          className={
            isNavBarOpen ? "setting-container" : "setting-container-close"
          }
        >
          <h3>Project Settings</h3>
          <div className="settings-details">
            <ProjectSettings />
          </div>
        </div>
      )}
      {openSection === "Timesheet" && (
        <div
          className={
            isNavBarOpen ? "setting-container" : "setting-container-close"
          }
        >
          <h3>Timesheet Settings</h3>
          <div className="settings-details">
            <TimesheetSettings />
          </div>
        </div>
      )}

      {openSection === "eventSettings" && (
        <div
          className={
            isNavBarOpen ? "setting-container" : "setting-container-close"
          }
        >
          <h3>Event Settings</h3>
          <div className="settings-details">
            <EventSettings />
          </div>
        </div>
      )}

      {openSection === "emailSettings" && (
        <div
          className={
            isNavBarOpen ? "setting-container" : "setting-container-close"
          }
        >
          <h3>Email Settings</h3>
          <div className="email-test-settings">
            <EmailSettings />
            <TestEmail />
          </div>
        </div>
      )}

      {/* Roles Settings Section */}

      {openSection === "roleSettings" && (
        <div
          className={
            isNavBarOpen ? "setting-container" : "setting-container-close"
          }
        >
          <h3>Roles Settings</h3>
          <div className="settings-details">
            <RoleSettings />
          </div>
        </div>
      )}
      {openSection === "groupSettings" && (
        <div>
          <div
            className={
              isNavBarOpen ? "setting-container" : "setting-container-close"
            }
          >
            <h3>Group Settings</h3>
            <div className="settings-details">
              <GroupList />
            </div>
          </div>
        </div>
      )}

      {openSection === "customerSettings" && (
        <div
          className={
            isNavBarOpen ? "setting-container" : "setting-container-close"
          }
        >
          <h3>Customer Settings</h3>
          <div className="settings-details">
            <CustomerList />
          </div>
        </div>
      )}

      {openSection === "companySettings" && (
        <div
          className={
            isNavBarOpen ? "setting-container" : "setting-container-close"
          }
        >
          <h3>Company Profile</h3>
          <div className="settings-details">
            <CompanyProfile />
          </div>
        </div>
      )}
      {openSection === "countries" && (
        <div
          className={
            isNavBarOpen ? "setting-container" : "setting-container-close"
          }
        >
          <h3>Country Settings</h3>
          <div className="settings-details">
            <Countries />
          </div>
        </div>
      )}
    </div>
  );
};

export default Settings;
